import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';

const GiftDisplay = ({ girlId }) => {
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGifts();
  }, [girlId]);

  const fetchGifts = async () => {
    try {
      const girlRef = doc(db, 'girls', girlId);
      const girlSnap = await getDoc(girlRef);
      
      if (girlSnap.exists()) {
        const girlData = girlSnap.data();
        setGifts(girlData.gifts || []);
      }
    } catch (error) {
      console.error('Error fetching gifts:', error);
    } finally {
      setLoading(false);
    }
  };

  const getGiftStats = () => {
    const stats = {
      car: 0,
      house: 0,
      hand: 0,
      total: 0
    };

    gifts.forEach(gift => {
      stats[gift.giftType] = (stats[gift.giftType] || 0) + 1;
      stats.total += gift.price;
    });

    return stats;
  };

  const stats = getGiftStats();

  if (loading) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-pink-500"></div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold mb-4 flex items-center">
        <span className="text-2xl mr-2">🎁</span>
        ของขวัญที่ได้รับ
      </h3>

      {/* สถิติของขวัญ */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="text-center bg-gray-50 p-3 rounded-lg">
          <div className="text-2xl mb-1">🚗</div>
          <div className="text-lg font-bold text-blue-600">{stats.car}</div>
          <div className="text-sm text-gray-600">รถ</div>
        </div>
        <div className="text-center bg-gray-50 p-3 rounded-lg">
          <div className="text-2xl mb-1">🏠</div>
          <div className="text-lg font-bold text-green-600">{stats.house}</div>
          <div className="text-sm text-gray-600">บ้าน</div>
        </div>
        <div className="text-center bg-gray-50 p-3 rounded-lg">
          <div className="text-2xl mb-1">👋</div>
          <div className="text-lg font-bold text-purple-600">{stats.hand}</div>
          <div className="text-sm text-gray-600">มือ</div>
        </div>
        <div className="text-center bg-gray-50 p-3 rounded-lg">
          <div className="text-2xl mb-1">💰</div>
          <div className="text-lg font-bold text-yellow-600">{stats.total}</div>
          <div className="text-sm text-gray-600">เหรียญรวม</div>
        </div>
      </div>

      {/* รายการของขวัญล่าสุด */}
      {gifts.length > 0 ? (
        <div>
          <h4 className="font-semibold mb-3">ของขวัญล่าสุด</h4>
          <div className="space-y-2 max-h-60 overflow-y-auto">
            {gifts.slice(-10).reverse().map((gift) => (
              <div
                key={gift.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div className="flex items-center space-x-3">
                  <span className="text-2xl">{gift.giftIcon}</span>
                  <div>
                    <div className="font-medium">{gift.giftName}</div>
                    <div className="text-sm text-gray-600">
                      จาก {gift.fromUserName}
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium text-blue-600">
                    {gift.price} เหรียญ
                  </div>
                  <div className="text-xs text-gray-500">
                    {new Date(gift.timestamp).toLocaleDateString('th-TH')}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <div className="text-4xl mb-2">🎁</div>
          <p>ยังไม่มีของขวัญ</p>
        </div>
      )}
    </div>
  );
};

export default GiftDisplay;






